__turbopack_context__.v({
  "container": "students-also-bought-module-scss-module__nxbmmG__container",
  "grid-container": "students-also-bought-module-scss-module__nxbmmG__grid-container",
  "unit-heading": "students-also-bought-module-scss-module__nxbmmG__unit-heading",
});
